<script>
export default {
  name: 'DataTable',
}
</script>

<template lang="pug">
table.table.table-hover.table-sm.small
  slot
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;
.table {
  &:deep(td),
  &:deep(th) {
    box-shadow: none;
    border-color: map.get(themeVariables.$colors, outlineVariant);
  }

  &:deep thead {
    top: 100px;
  }

  &:deep > :not(:first-child) {
    border-top: none;
  }

  &:deep(thead tr:first-child) {
    background: map.get(themeVariables.$specificColors, tableHeaderCellBackground);

    &:hover {
      background: map.get(themeVariables.$specificColors, tableHeaderCellBackground);
    }
  }

  & > :not(:first-child) {
    border-top: none;
  }
}
</style>
